import { Component, input } from '@angular/core';

import { TableRowData } from '@app/shared/models/table-data-types';
import {
    ColumnConfig,
    ColumnValue,
} from '@app/shared/services/view-configs/column-creator';

@Component({
    selector: 'app-text-display',
    template: `{{ displayValue }}`,
    standalone: true,
    imports: [],
})
export class TextDisplayComponent {
    value = input<ColumnValue>();
    row = input<TableRowData>();
    column = input<ColumnConfig>();
    index = input<number>(0);
    parentRow = input<TableRowData>();

    get displayValue(): string {
        return String(this.value()) || '';
    }
}
